import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAMVdVHrdSkFG4U5_WdRioyaqjdWWJN0gw",
  authDomain: "sagefusion-it.firebaseapp.com",
  projectId: "sagefusion-it",
  storageBucket: "sagefusion-it.firebasestorage.app",
  messagingSenderId: "676732321338",
  appId: "1:676732321338:web:5ef44af037a9f233183f03",
  measurementId: "G-LHG8XRX22L",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export { app, auth };
